import { useRecoilState, useRecoilValue } from 'recoil';

import { Dialog, DialogContent } from '@/components/ui/dialog';

import {
  auditLogDialogOpenState,
  auditLogUserIdentifierState
} from '@/state/project';

import AuditLogSection from './AuditLogSection';

/**
 * Audit log in a full-screen dialog, driven by Recoil so anything can open it.
 *
 * Mounted globally in `pages/Page.tsx` next to `UserDetailDialog` rather than
 * inside `AdminSection`, so it survives the settings sidebar closing and can be
 * opened from the user detail dialog — which is itself global and has no path to
 * the admin pane's local state.
 */
export default function AuditLogDialog() {
  const [open, setOpen] = useRecoilState(auditLogDialogOpenState);
  const userIdentifier = useRecoilValue(auditLogUserIdentifierState);

  return (
    <Dialog open={open} onOpenChange={setOpen}>
      <DialogContent
        className="w-[92vw] max-w-[1400px] h-[85vh] min-h-0 sm:min-h-[600px] flex flex-col gap-4 p-6 sm:p-8 box-border overflow-hidden"
        aria-describedby={undefined}
      >
        <div className="flex-1 overflow-y-auto pr-4">
          <AuditLogSection
            initialUserIdentifier={userIdentifier ?? undefined}
          />
        </div>
      </DialogContent>
    </Dialog>
  );
}
